import api from 'api';

type GetContainersType = {id: number | string}

export const getContainers = async ({ id }:GetContainersType) => api().get(`/containers/${id}`);

export const createContainers = async ({ data }) => api().post('/containers', data);

export const updateContainers = async ({ id, data }) => api().put(`/containers/${id}`, data);
